import cx from 'classnames';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: cx.ArgumentArray): string {
  return twMerge(cx(inputs));
}
